<template>
  <el-form class="biddingmonitoring">
    <div class="biddingmonitoring-box">
      <div class="biddingmonitoring-header">
        <div class="biddingmonitoring-center">
          <div class="biddingmonitoring-title"><i class="title-decorate iconfont icon-decorate" />{{ detail.biddingStatusName }}</div>
          <Countdown v-if="nowTime && ifHasCutdown" :now-time="nowTime" :detail="detail" @time-down="timeDown" />
        </div>
        <div>
          <el-button @click="$router.back()">{{ $t('bidmanagementpur.biddingmonitoring.back') }}</el-button>
          <el-button type="primary" :disabled="!ifHasCutdown" @click="submit">{{ $t('bidmanagementsup.biddinghall.submit') }}</el-button>
        </div>
      </div>
      <div class="biddingmonitoring-title" style="transform: translateY(10px);">{{ detail.biddingName }}</div>
      <div><HeaderInfo :data="detail" /></div>
    </div>

    <div class="biddingmonitoring-box">
      <div class="biddingmonitoring-header">
        <div class="biddingmonitoring-title"><i class="title-decorate iconfont icon-decorate" />{{ $t('bidmanagementsup.enroll.biddingDetail') }}</div>
      </div>
      <div><component :is="table.tpl()" :[tableProp]="table" :list="goodsList" style="padding: 10px 0 0" /></div>
    </div>

    <bidRule :form="detail" :is-edit="false" is-display />

    <bidNotice :form="detail" :is-edit="false" is-display />

    <div class="biddingmonitoring-box">
      <div class="biddingmonitoring-header">
        <div class="biddingmonitoring-title"><i class="title-decorate iconfont icon-decorate" />{{ $t('bidmanagementsup.enroll.joinsup') }}</div>
      </div>
      <div><component :is="supplierTable.tpl()" :[tableProp]="supplierTable" :list="supplierList" style="padding: 10px 0 0" /></div>
    </div>
  </el-form>
</template>

<script>
import http from '@/plugin/axios'
import Countdown from './countdown'
import HeaderInfo from '@/views/purchaser/bidmanagementpur/mybidding/biddingmonitoring/components/header-info'
import emitter from 'element-ui/src/mixins/emitter'
import Detail from '@/views/purchaser/bidmanagementpur/mybidding/detail/detail'
import Table from '@utils/table'
import PreviewFile from '@/components/select/upload-select/preview-file'
import bidRule from '@/views/purchaser/bidmanagementpur/mybidding/components/bidRule'
import bidNotice from '@/views/purchaser/bidmanagementpur/mybidding/components/bidNotice'
import { $t } from '@/plugin/i18n'

function parseFile(files = []) {
  return files.map(item => {
    return {
      name: item.fileName,
      url: '/srmFile/getFile',
      baseURL: process.env.VUE_APP_BASE_API,
      fileId: item.fileId,
      data: { fileId: `${item.fileId}` }
    }
  })
}

const table = new Table('bidmanagementsup.biddinghall')
  .type('index')
  .sortable(false)
  .add('goodsType')
  .add('number')
  .add('name')
  .add('model')
  .add('category')
  .add('technologyName')
  .add('unit')
  .add('currencyNo')
  .add('qty')
  .add('fixedPrice')
  .add('purchaseStandard')
  .add('expectedDeliveryDate')
  .add('goodsFileList').component(PreviewFile).bind('parse', parseFile)

const supplierTable = new Table('bidmanagementsup.enroll')
  .type('index')
  .sortable(false)
  .add('supOfficeName')
  .add('status').format(({ value }) => value === '1' || value === '2' ? $t(`bidmanagementsup.enroll.statusNames[${value}]`) : $t('bidmanagementsup.enroll.statusNames[0]'))
  .add('adddate')

export default {
  components: {
    Countdown,
    HeaderInfo,
    Detail,
    bidRule,
    bidNotice
  },
  mixins: [emitter],
  data() {
    return {
      nowTime: null,
      detail: {},
      list: [],
      supplierList: [],
      loading: false,
      showMore: false
    }
  },
  computed: {
    ifHasCutdown() {
      if (!this.nowTime) return false
      if (!this.detail.signUpDeadline) return false
      const nowTime = new Date(this.nowTime).getTime()
      const endTime = new Date(this.detail.signUpDeadline).getTime()
      return nowTime < endTime
    },
    closedAll() {
      if (!this.list.length) return false
      const list = this.list.filter(i => i.show)
      return !list.length
    },
    canBidSign() {
      return this.detail.canBidSign === 'Y'
    },
    goodsList() {
      return this.detail.goodsList || []
    },
    table() {
      return table
    },
    supplierTable() {
      return supplierTable
    },
    tableProp() {
      return '$table'
    }
  },
  async created() {
    this.nowTime = await http({
      url: '/getServerDate',
      baseURL: process.env.VUE_APP_BASE_API,
      data: {},
      loading: true
    })

    this.detail = await http({
      url: '/srmBiddingHead/getBiddingMonitorDetail',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { id: this.$route.params.id },
      loading: true
    })

    const supplierList = await http({
      url: '/srmBiddingHead/getInviteSupplierList',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { id: this.$route.params.id },
      loading: true
    })
    this.supplierList = Object.freeze(supplierList)
  },
  methods: {
    timeDown() {
      this.dispatch('Layout', 'layout.refresh', [this])
    },
    async submit() {
      await this.$confirm('是否报名？')
      await http({
        url: '/srmBiddingHead/sign',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { id: this.$route.params.id },
        loading: true
      })
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.biddingmonitoring {
  &-box {
    position: relative;
    padding: 12px;
    background: #fff;
    margin-bottom: 12px;
  }
  &-white {
    padding: 12px;
    background: #fff;
  }

  &-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  &-center {
    display: inline-flex;
    align-items: center;
  }

  &-title {
    display: inline-flex;
    align-items: center;
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    .title-decorate {
      transform: scale(.7);
      color: #008EE3;
      margin-right: 2px;
    }
  }

  &-more {
    font-size: 13px;
    color: #008ee3;
    height: 36px;
    line-height: 36px;
    background-color: #E1F4FF;
    position: absolute;
    padding: 0 18px;
    top: 12px;
    right: 0px;
    cursor: pointer;
    &::before {
      content: '';
      width: 20px;
      height: 36px;
      background-color: #E1F4FF;
      position: absolute;
      transform: skew(-20deg);
      left: -8px;
      border-radius: 4px;
    }
  }

  &-round-tab {
    margin-left: 15px;
    background-color: #E7F6FF;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border-radius: 4px;
    color: #008ee3;
    font-size: 12px;
  }

  &-button {
    display: inline-block;
    font-size: 12px;
    margin-left: 22px;
    cursor: pointer;
  }
}
</style>
